import { render, staticRenderFns } from "./safetyHealthObliDetail.vue?vue&type=template&id=13fac474"
import script from "./safetyHealthObliDetail.vue?vue&type=script&lang=js"
export * from "./safetyHealthObliDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('13fac474')) {
      api.createRecord('13fac474', component.options)
    } else {
      api.reload('13fac474', component.options)
    }
    module.hot.accept("./safetyHealthObliDetail.vue?vue&type=template&id=13fac474", function () {
      api.rerender('13fac474', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sai/obli/safetyHealthObliDetail.vue"
export default component.exports